import EventEmitter from 'events';
var eventCenter = new EventEmitter();

if (eventCenter.setMaxListeners) {
  eventCenter.setMaxListeners(10);
}

export { eventCenter };
export var SYNC_EVENT = 'recharts.syncMouseEvents';


//////////////////
// WEBPACK FOOTER
// ./node_modules/recharts/es6/util/Events.js
// module id = 1076
// module chunks = 0